import React from 'react'
import axios from '~/data/http/axios';
import Alert from '~/Common-Objects/UI/Alert'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import GroupSelector from '~/Common-Objects/UI/GroupSelector/GroupSelector'
import { connect } from 'react-redux';
import * as siteMaster from '~/data/actions/siteActions'; //now we can use user actions here
import i18n from '~/i18n';

@connect((store) => {
    return { user: store.user }
})
export default class IncGoAddGroup extends React.Component {

    constructor(props, context) {
        super(props);
        this.state = {
            selectedGroup: undefined
        };
        this.forwarder = this.forwarder.bind(this);
        this.cancel = this.cancel.bind(this);
    }

    forwarder() {
        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, "right", null, true));
        this.props.history.push('/cp/groups/' + this.state.selectedGroup.id + '/add')
    }
    cancel() {
        this.props.dispatch(siteMaster.alterSiteDrawer(false, false, "right", null, true));
    }

    render() {

        return <div>

            <h4 className="mar-b10">{i18n.t('subscribers:addPopup.title')}</h4>
            <div className="mar-b25">{i18n.t('subscribers:addPopup.subTitle')}</div>
            <GroupSelector groupChanged={(group) => {
                this.setState({ selectedGroup: group });
            }} />

            <div className="mar-b50">
                {this.state.selectedGroup && <Button
                    className="button-primary mar-r5"
                    text={i18n.t('subscribers:addPopup.continue')}
                    onClick={this.forwarder}
                />}

                <Button
                    className=""
                    text={i18n.t('subscribers:addPopup.cancel')}
                    onClick={this.cancel}
                />

            </div>

            <Alert
                className=""
                type="info"
                header={i18n.t('subscribers:addPopup.infoHeader')}
                content={i18n.t('subscribers:addPopup.infoContent')}
            />



        </div >
    }
};

